<template>
   <div>
    <h3>Report Guide</h3>
    <div class=" modal-label">
        <h5 class="mb-4 mt-4">1. Creating reports</h5>
        <div class="card">
            <div class="card-body">
                <p class="p-guide"> 
                    <b>1.1</b>
                    In order to create a report, go to the main reports screen and click on the link text with the description “Create new report”
                    <img src="/assets/img/guides/reports/report-create.png" class="img-report"/>
                </p>
            </div>
        </div>
             
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>1.2</b>
                    A modal will appear with all the modules of the system, select the module from which you want to create a report and click the "Ok" button
                    <img src="/assets/img/guides/reports/report-modal-creation.png" class="img-report"/>
                </p>
             </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>1.3</b>
                    After clicking the "Ok" button, you will be redirected to the report detail screen. On the left side of the screen, there will be a dropdown list with all the report columns. By default, all columns will be selected, but you can deselect columns that you don't want to display in the report
                    <img src="/assets/img/guides/reports/report-dropdown-columns.png" class="img-report"/>
                </p>
            </div>
        </div>
         <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>1.4</b>
                     You can also filter the report list by its columns values. Click the "Filter" button on the tab and select the values you want to filter the report by
                    <img src="/assets/img/guides/reports/detail-filter.png" class="img-report"/>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>1.5</b>
                    There are two ways to save the report
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>1.5.1</b>
                    Click the “Save” button, then it will show you two options
                    <img src="/assets/img/guides/reports/detail-save-button.png" class="img-report"/>
                </p>
            </div>
        </div>
         <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>1.5.1.1</b>
                     "Save" option: It will save the report and you will be redirected to the main reports screen
                    <img src="/assets/img/guides/reports/save-button-displaying.png" class="img-report"/>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>1.5.1.2</b>
                    "Save As" option: It will prompt out a modal to save the report with a custom name
                    <img src="/assets/img/guides/reports/save-button-displaying-2.png" class="img-report"/>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>1.5.2</b>
                    “Save and Run” button: It will save the report and you will be redirected to the screen for exporting the report
                    <img src="/assets/img/guides/reports/detail-save-button-2.png" class="img-report"/>
                </p>
            </div>
        </div>
        <h5 class="mb-4 mt-5">2. Exporting reports</h5>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>2.1</b>
                    After creating a report or clicking on a report name on the main reports screen, you will be redirected to the report detail screen
                    <img src="/assets/img/guides/reports/name-report.png" class="img-report"/>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>2.2</b>
                    Here you have two buttons to go to the export screen
                    <img src="/assets/img/guides/reports/two-options-run.png" class="img-report"/>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>2.2.1</b>
                    "Save and Run" Button: It will save the last changes in the report and you'll be redirected to the export screen
                     <img src="/assets/img/guides/reports/1-option-run.png" class="img-report"/>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>2.2.2</b>
                    "Run" button: After you have created a report and not saved it yet, this button will be visible for you. Clicking on it will not save the report and you will be redirected to the export screen
                    <img src="/assets/img/guides/reports/2-option-run.png" class="img-report"/>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>2.3</b>
                    On the export screen, there is a button with the description “Export", clicking on it will display a menu with three options
                    <img src="/assets/img/guides/reports/options-export-button.png" class="img-report"/>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>2.3.1</b>
                    "Export to Excel" option: It will download the report in csv format
                     <img src="/assets/img/guides/reports/options-export-button-excel.png" class="img-report"/>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>2.3.2</b>
                "Export as PDF Portrait" option: It will download the report in pdf format in vertical layout
                <img src="/assets/img/guides/reports/options-export-button-pdf-1.png" class="img-report"/>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="p-guide">
                    <b>2.3.3</b>
                "Export to PDF Landscape" option: It will download the report in pdf format in horizontal layout
                <img src="/assets/img/guides/reports/options-export-button-pdf-2.png" class="img-report"/>
                </p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
